import { NameSlateTool } from '@/components/NameSlateTool';

const NameSlatePage = () => {
  return <NameSlateTool />;
};

export default NameSlatePage;
